var map = {
	"./bg-download.png": 4181,
	"./bg-top.png": 5820,
	"./bg1.png": 5681,
	"./bg2.png": 8250,
	"./bg3.png": 163,
	"./female.png": 3243,
	"./ic_add.png": 2239,
	"./ic_arrow.png": 4249,
	"./ic_chat.png": 8858,
	"./ic_feed_null.png": 86,
	"./ic_like.png": 3905,
	"./ic_live.png": 9198,
	"./kimy.png": 5093,
	"./live.gif": 354,
	"./live.png": 8437,
	"./male.png": 6340,
	"./mico.png": 8447,
	"./micolite.png": 4755,
	"./play.gif": 9522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6507;